import styled from 'styled-components';

export const Heading = styled.div`
    ${props => props.isChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    color: ${props => props.white ? `#ffffff` : `#2c3e50`};
    font-weight: ${props => props.bold ? 'bold' : 'normal'};
    font-size: 25px;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
`;

export const Text = styled.div`
    ${props => props.isChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    color: ${props => props.white ? `#ffffff` : `#2c3e50`};
    font-size: 20px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
`;

export const SmallText = styled.div`
    ${props => props.isChinese
        ? `font-family: 'Microsoft JhengHei', 'Arial', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    color: #000000;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
`;
// letter-spacing: 0.6px;
